import moment from 'moment'
import useIPA from '@/auth/jwt/useDevice'

const state = () => ({
  reportMHD: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'time', label: 'Date Time', sortable: true, thClass: 'label-nowrap', tdClass: 'label-nowrap' },
      { key: 'ph', label: 'PH', sortable: true },
      { key: 'nh3n', label: 'NH3', sortable: true },
      { key: 'cod', label: 'COD', sortable: true },
      { key: 'tss', label: 'TSS', sortable: true },
      { key: 'flow', label: 'Debit', sortable: true },
      { key: 'ph_status', label: 'Status PH', sortable: true, thClass: 'label-nowrap' },
      { key: 'nh3n_status', label: 'Status NH3N', sortable: true, thClass: 'label-nowrap' },
      { key: 'cod_status', label: 'Status COD', sortable: true, thClass: 'label-nowrap' },
      { key: 'tss_status', label: 'Status TSS', sortable: true, thClass: 'label-nowrap' },
      { key: 'flow_status', label: 'Status Debit', sortable: true, thClass: 'label-nowrap' },
      { key: 'ups', label: 'Status UPS', sortable: true, thClass: 'label-nowrap' },
      { key: 'pln', label: 'Status PLN', sortable: true, thClass: 'label-nowrap' },
      { key: 'ph_alarm', label: 'Alarm PH', sortable: false, thClass: 'label-nowrap' },
      { key: 'nh3n_alarm', label: 'Alarm NH3N', sortable: false, thClass: 'label-nowrap' },
      { key: 'cod_alarm', label: 'Alarm COD', sortable: false, thClass: 'label-nowrap' },
      { key: 'tss_alarm', label: 'Alarm TSS', sortable: false, thClass: 'label-nowrap' },
      { key: 'debit_alarm', label: 'Alarm Debit', sortable: false, thClass: 'label-nowrap' },
      { key: 'rssi', label: 'RSSI', sortable: true },
      { key: 'provider', label: 'Operator Name', sortable: true, thClass: 'label-nowrap' },
    ],
    items: [],
  },
})

const getters = {}

const actions = {
  getReportMHD({ commit }, params) {
    const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
    const param = {
      status: `internal/master/historical-devices/raw?date_start=${params.date_start}&date_finish=${params.date_finish}&project_id=${params.project_id}&page=${params.page}&limit=${params.limit}&search=${params.search}${orderBy}`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data,
      }
      commit('setReportMHD', { ...Data })
    })
  },
}

const mutations = {
  setReportMHD(state, dashboard) {
    dashboard.rows.data.forEach((element, index) => {
      element.no = index + 1
    })
    state.reportMHD.items = dashboard.rows.data
    state.reportMHD.items.map((x => (
      x.time = moment(x.created_at).format('YYYY-MMM-DD, HH:mm:ss'),
      x.debit = parseFloat(x.flow).toFixed(2)
    )))
    state.reportMHD.totalRows = dashboard.rows.pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}